import { useContext } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import useToast from "../../../hooks/useToast";
import { PaymentFormContext } from "../../../Shared/components/PaymentForm/PaymentFormContext";
import { useOpenBalanceContext } from "../context/OpenBalanceContext";
import { cancelButtonOnClick, submitPayment } from "../utils/openBalance-helpers";
import { BillingInformationContext } from "../../BillingInformation/BillingInformationContext";
export const usePaymentFormButtons = () => {
    var _a;
    const OBP = useOpenBalanceContext();
    const navigate = useNavigate();
    const toast = useToast();
    const { balance, giftCard, paymentMethod } = useContext(PaymentFormContext);
    const { paymentIntentId, paymentProcessor, resetContext: resetBillingInfoContext, } = useContext(BillingInformationContext);
    const requestVars = {
        amount: balance === null || balance === void 0 ? void 0 : balance.remainingBalance,
        giftCardId: giftCard === null || giftCard === void 0 ? void 0 : giftCard.id,
        orderId: balance === null || balance === void 0 ? void 0 : balance.orderId,
        paymentMethodId: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id,
        setIsLoading: OBP.setIsLoading,
        setPaymentComplete: OBP.setPaymentComplete,
        toast,
        paymentIntentId,
        paymentProcessor,
        resetBillingInfoContext,
    };
    const giftCardCoversBalance = !!(giftCard === null || giftCard === void 0 ? void 0 : giftCard.balance) && giftCard.balance > ((_a = balance === null || balance === void 0 ? void 0 : balance.remainingBalance) !== null && _a !== void 0 ? _a : 0);
    const canBalanceBePaid = !!paymentMethod || giftCardCoversBalance;
    const disableButton = !(balance === null || balance === void 0 ? void 0 : balance.remainingBalance) || !(balance === null || balance === void 0 ? void 0 : balance.orderId) || !canBalanceBePaid;
    return {
        cancelButtonOnClick: cancelButtonOnClick(navigate),
        disableButton,
        isLoading: OBP.isLoading,
        isMobile: OBP.isMobile,
        submitPayment: submitPayment(requestVars),
    };
};
